module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "sgc-toc-title"
  }, [_c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/01_Fm01"
    }
  }, [_vm._v("Dedication")]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/02_Fm02"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_Part01"
    }
  }, [_vm._v("I   "), _c('span', {
    staticClass: "bigcaps"
  }, [_vm._v("Drunk With Love")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/05_Chapter01"
    }
  }, [_vm._v("Drunk With Love")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/06_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineteen Forty-One")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/07_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Expansion of the Universe")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/08_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adoration")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/09_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II   "), _c('span', {
    staticClass: "bigcaps"
  }, [_vm._v("Bad Times in a Good Land")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emancipator")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memphis")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Young Man")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Manhattans")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cast Diet")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III   "), _c('span', {
    staticClass: "bigcaps"
  }, [_vm._v("The Islands")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Blue-Eyed Buddhist")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belize")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV   "), _c('span', {
    staticClass: "bigcaps"
  }, [_vm._v("The Dishes Can Wait")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traceleen at Dawn")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anna, Part 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_Other",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Ellen Gilchrist")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connect with Diversion Books")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0